export default __webpack_public_path__ + "static/media/mariadb-logo-vert_blue-transparent-1.78866dd0.png";